import api from './api';

const promotionsService = {
  // Get all content cards for the authenticated agent
  getAll: async () => {
    const response = await api.get('/promotions');
    return response.data;
  },

  // Get a single content card by ID
  getById: async (id) => {
    const response = await api.get(`/promotions/${id}`);
    return response.data;
  },

  // Create a new content card
  create: async (contentCardData) => {
    const response = await api.post('/promotions', contentCardData);
    return response.data;
  },

  // Update an existing content card
  update: async (id, contentCardData) => {
    const response = await api.put(`/promotions/${id}`, contentCardData);
    return response.data;
  },

  // Delete a content card
  delete: async (id) => {
    const response = await api.delete(`/promotions/${id}`);
    return response.data;
  },

  // Toggle content card active status
  toggleActive: async (id, isActive) => {
    const response = await api.patch(`/promotions/${id}/toggle`, { is_active: isActive });
    return response.data;
  },

  // Get suppliers for dropdown
  getSuppliers: async () => {
    const response = await api.get('/promotions/suppliers');
    return response.data;
  },

  // Get categories for dropdown
  getCategories: async () => {
    const response = await api.get('/promotions/categories');
    return response.data;
  }
};

export default promotionsService;
